import React,{useState} from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet
} from '@react-pdf/renderer';
import chunk from 'lodash/chunk';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 8,
    fontFamily: 'Helvetica',
    position: 'relative',
  },
  title: {
    fontSize: 12,
    marginBottom: 10,
    textAlign: 'center'
  },
  sectionTitle: {
    fontSize: 10,
    marginTop: 6,
    marginBottom: 4,
    fontWeight: 'bold'
  },
  subSectionTitle: {
    fontSize: 9,
    marginTop: 4,
    marginBottom: 2,
    fontWeight: 'bold',
    marginLeft: 10
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderColor: "#ccc",
    paddingVertical: 2,
    fontSize: 8,
    marginLeft: 20
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: "#000",
    paddingVertical: 3,
    backgroundColor: "#eee"
  },
  cell: {
    paddingHorizontal: 3
  },
  colGroupCode: { width: "10%" },
  colGroupDesc: { width: "70%" },
  colJumlah: { width: "20%", textAlign: "right" },
  footerRow: {
    flexDirection: "row",
    backgroundColor: "#f9f9f9",
    borderTopWidth: 1,
    borderColor: "#000",
    paddingTop: 2,
    marginLeft: 10
  },

 totalGroupCode: {
  width: '30%', // atau sesuai yang kamu mau
  fontWeight: 'bold',
  textAlign: 'left',
  paddingLeft: 4,
  paddingRight:10
},


 totalDiv: {
  width: '30%', // atau sesuai yang kamu mau
  fontWeight: 'bold',
  textAlign: 'left',
  paddingLeft: 4
  // paddingRight:10
},

  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    top: 10,
    right: 30,
    textAlign: 'right',
    color: 'grey'
  }
});

const formatCurrency = val => Number(val || 0).toLocaleString('id-ID');

const groupBy = (arr, key) => {
  return arr.reduce((acc, item) => {
    const groupKey = item[key];
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
};

const formatDateTime = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
                 "Juli", "Agustus", "September", "Oktober", "November", "Desember"][d.getMonth()];
  const year = d.getFullYear();
  const time = d.toTimeString().split(' ')[0]; // ambil HH:MM:SS

  return `${day}-${month}-${year} ${time}`;
};


const MyReportneracaday = ({ data = [], tanggal, userBy }) => {
  const groupedByDiv = groupBy(data, 'group_account_div');
  
  const formattedDate = new Date().toLocaleString('id-ID', {
    month: 'long',
    year: 'numeric',
  });
  // const [date,setDate] = useState(new Date().toLocaleString())
  const [date, setDate] = useState(formatDateTime());
 
   

  const rows = [];

  Object.entries(groupedByDiv).forEach(([divKey, divRecords]) => {
    const groupedByDep = groupBy(divRecords, 'group_account_dep');
    const totalDiv = divRecords.reduce((sum, r) => sum + (r.jumlah || 0), 0);

    rows.push(
      <Text key={`${divKey}-title`} style={styles.sectionTitle}>
        {divKey}
      </Text>
    );

    Object.entries(groupedByDep).forEach(([depKey, depRecords]) => {
      const totalDep = depRecords.reduce((sum, r) => sum + (r.jumlah || 0), 0);

      rows.push(
        <Text key={`${divKey}-${depKey}-subtitle`} style={styles.subSectionTitle}>
          {depKey}
        </Text>
      );

      depRecords.forEach((r, i) => {
        rows.push(
          <View style={styles.tableRow} key={`${divKey}-${depKey}-row-${i}`}>
            <Text style={[styles.cell, styles.colGroupCode]}>{r.group_account_code}</Text>
            <Text style={[styles.cell, styles.colGroupDesc]}>{r.group_account_desc}</Text>
            <Text style={[styles.cell, styles.colJumlah]}>{formatCurrency(r.jumlah)}</Text>
          </View>
        );
      });

      rows.push(
        <View style={styles.footerRow} key={`${divKey}-${depKey}-subtotal`}>
          <Text style={[styles.cell, styles.colGroupCode]}>Subtotal</Text>
          <Text style={[styles.cell, styles.colGroupDesc]}></Text>
          <Text style={[styles.cell, styles.colJumlah]}>{formatCurrency(totalDep)}</Text>
        </View>
      );
    });

    rows.push(
      <View style={styles.footerRow} key={`${divKey}-total`}>
        {/* <Text style={[styles.cell, styles.colGroupCode]}>Total {divKey}</Text> */}
        <Text style={[styles.cell, styles.totalGroupCode]}>Total {divKey}</Text>
        <Text style={[styles.cell, styles.colGroupDesc]}></Text>
        <Text style={[styles.cell, styles.colJumlah]}>{formatCurrency(totalDiv)}</Text>
      </View>
    );
  });

  const rowsPerPage = 50;
  const pages = chunk(rows, rowsPerPage);

  return (
    <Document>
      {pages.map((rowsChunk, idx) => (
        <Page key={idx} size="A4" orientation="portrait" style={styles.page}>
          <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `Halaman: ${pageNumber} dari ${totalPages}`} fixed />
          <Text style={styles.title}>Laporan Neraca &nbsp;&nbsp; Periode : {tanggal} </Text>
          <Text> 
              Tanggal : {date} &nbsp;&nbsp;&nbsp;&nbsp;user by : {userBy}
          </Text>          
          <View style={styles.tableHeader} fixed>
            <Text style={[styles.cell, styles.colGroupCode]}>Group Code</Text>
            <Text style={[styles.cell, styles.colGroupDesc]}>Group Desc</Text>
            <Text style={[styles.cell, styles.colJumlah]}>Jumlah</Text>
          </View>
          {rowsChunk}
        </Page>
      ))}
    </Document>
  );
};

export default MyReportneracaday;
